module.exports = __webpack_public_path__ + "static/media/bgr-three-md.309dc3f8.webp";